const ICON_PROP_KEYS = [ "type", "content", "style", "color", "width", "height", "marginRight", "marginLeft", "src", "svg", "name", "path", "positionType", "tooltip", "hover", "cursor", "shape", "interactive", "isGif" ];

export const iconPropKeys = ICON_PROP_KEYS;
//# sourceMappingURL=icons.js.map
